// extracted by mini-css-extract-plugin
export default {"edit":"editAddress_edit__lN0jA","heading":"editAddress_heading__LlgwB","saveBtn":"editAddress_saveBtn__TWByJ"};